(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nysom-desktop-nav"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){document.querySelectorAll('.nysom-shop-menu[open]').forEach(function(menu){if(!menu.contains(event.target))menu.open=false;});});
document.addEventListener('keydown',function(event){if(event.key==='Escape'){document.querySelectorAll('.nysom-shop-menu[open]').forEach(function(menu){menu.open=false;menu.querySelector('summary').focus();});}});
  } catch(e) { console.error(e); }
})();

})();
